"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _digiwashCore = require("digiwash-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LogisticTaskStatus(props) {
  return /*#__PURE__*/_react.default.createElement(_.Box, {
    bg: (0, _digiwashCore.taskStatusToBackgroundColor)(props.status),
    px: "xm",
    py: "m",
    br: "l"
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    color: (0, _digiwashCore.taskStatusToColor)(props.status),
    fs: "s"
  }, (0, _digiwashCore.taskStatusToPersian)(props.status)));
}

var _default = LogisticTaskStatus;
exports.default = _default;